"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M17.026 1.5H5.974C4.884 1.5 4 2.433 4 3.583v15.834c0 1.15.884 2.083 1.974 2.083h11.052c1.09 0 1.974-.933 1.974-2.083V3.583c0-1.15-.884-2.083-1.974-2.083zM11.5 20.667c-.655 0-1.184-.559-1.184-1.25 0-.692.529-1.25 1.184-1.25.655 0 1.184.558 1.184 1.25 0 .691-.529 1.25-1.184 1.25zm5.921-3.334H5.58V4H17.42v13.333z" }), "ResolutionMediumPortrait");
//# sourceMappingURL=ResolutionMediumPortrait.js.map